// @flow
import React from 'react';

type Props = {
  taxiType: string,
  handlePercentageChange: Function,
}

export default function TaxiTypeInput(props: Props) {
  return (
    <tr key={props.taxiType}>
      <td className="centralize">{props.taxiType}</td>
      <td className="alignment">
        <input
          className="input is-small"
          type="number"
          placeholder="0"
          onChange={(event) => {
            props.handlePercentageChange(props.taxiType, event);
          }}
          onKeyPress={(e: Object) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }}
        />
      </td>
    </tr>
  );
}



/** WEBPACK FOOTER **
 ** ./src/js/views/autosim/simulation/components/TaxiTypeInput.js
 **/